import axios from 'axios';

import config from "@Config";

import Cookies from './cookies-helper';
import history from './history';

function getSessionHeaders() {
  const session_id = Cookies.getSessionId() || JSON.parse(localStorage.getItem('session') || '{}').session_id
  if (session_id) {
    return {
      'X-UE-API-VERSION': 'v2',
      'X-API-Key': session_id,
    }
  }

  return null
}

const host = '';
const API_RESPONSE_INTERCEPTORS = [
  res => {
    Cookies.updateSessionExpiration()
    return res
  },
  error => {
    if (error.response && (error.response.status === 401 || error.response.status === 403)) {
      const unauthorizedSession = ['API-Key Invalid ', 'API-Key disabled', 'API-Key Expired'].includes(error.response.data)
      if (unauthorizedSession) {
        localStorage.removeItem('session');
        Cookies.clearSession();
      }
      history.push(unauthorizedSession ? '/auth/login' : '/');
    }

    return Promise.reject(error);
  },
]
const API_DEFAULT_HEADERS = getSessionHeaders()

export const API_HOST = host;

const legacyClient = axios.create({
  baseURL: host,
  withCredentials: true,
  headers: API_DEFAULT_HEADERS,
});
legacyClient.interceptors.response.use(...API_RESPONSE_INTERCEPTORS)
export default legacyClient;

export const internalApi = axios.create({
  baseURL: config.api,
  withCredentials: true,
  headers: API_DEFAULT_HEADERS,
});
internalApi.interceptors.response.use(...API_RESPONSE_INTERCEPTORS)

export const cmsApi = axios.create({
  baseURL: config.cms,
  withCredentials: true,
  headers: null,
});
